module.exports = "/deep/ .row-color {\r\n  background-color: #f8d7da;\r\n}\r\n"